import React, { useMemo } from "react";
import {
  formatSchedulePreview,
  TRAINING_VIDEO_DAY_FIELDS,
  TRAINING_VIDEO_WEEK_FIELDS,
  TrainingVideoScheduleFlags,
} from "../utils/trainingVideoSchedule";

interface TrainingVideoScheduleGridProps {
  value: TrainingVideoScheduleFlags;
  onChange: (next: TrainingVideoScheduleFlags) => void;
}

const TrainingVideoScheduleGrid: React.FC<TrainingVideoScheduleGridProps> = ({
  value,
  onChange,
}) => {
  const toggleFlag = (key: keyof TrainingVideoScheduleFlags) => {
    onChange({
      ...value,
      [key]: !value[key],
    });
  };

  const preview = useMemo(() => formatSchedulePreview(value), [value]);

  return (
    <div className="border border-gray-200 rounded overflow-hidden">
      <table className="min-w-full text-sm">
        <tbody>
          <tr className="bg-gray-50">
            <td className="px-3 py-3 border-b border-gray-200 font-semibold whitespace-nowrap align-middle w-24">
              Weeks
            </td>
            <td className="px-3 py-3 border-b border-gray-200">
              <div className="flex flex-wrap gap-x-4 gap-y-2">
                {TRAINING_VIDEO_WEEK_FIELDS.map(({ key, label }) => (
                  <label
                    key={key}
                    className="inline-flex items-center gap-2 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={Boolean(value[key])}
                      onChange={() => toggleFlag(key)}
                      className="h-4 w-4 accent-teal-600"
                    />
                    <span>{label}</span>
                  </label>
                ))}
              </div>
            </td>
          </tr>
          <tr>
            <td className="px-3 py-3 font-semibold whitespace-nowrap align-middle">
              Days
            </td>
            <td className="px-3 py-3">
              <div className="flex flex-wrap gap-x-4 gap-y-2">
                {TRAINING_VIDEO_DAY_FIELDS.map(({ key, label }) => (
                  <label
                    key={key}
                    className="inline-flex items-center gap-2 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={Boolean(value[key])}
                      onChange={() => toggleFlag(key)}
                      className="h-4 w-4 accent-teal-600"
                    />
                    <span>{label}</span>
                  </label>
                ))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {preview.length > 0 && (
        <div className="px-3 py-2 bg-teal-50 border-t border-teal-100 text-sm text-teal-900">
          <span className="font-medium">Schedule: </span>
          {preview.join(" · ")}
        </div>
      )}
    </div>
  );
};

export default TrainingVideoScheduleGrid;
